// extracted by mini-css-extract-plugin
module.exports = {"accordionIcon":"FooterLinks_accordionIcon__4z1K4","footerLinksContainer":"FooterLinks_footerLinksContainer__LrWv5","footerLinksList":"FooterLinks_footerLinksList__9KrE_"};